/* unplugin-vue-components disabled */import { render } from "./WeekReport.vue?vue&type=template&id=2d8ecb7c&scoped=true"
import script from "./WeekReport.vue?vue&type=script&lang=js"
export * from "./WeekReport.vue?vue&type=script&lang=js"

import "./WeekReport.vue?vue&type=style&index=0&id=2d8ecb7c&lang=less&scoped=true"
import "./WeekReport.vue?vue&type=style&index=1&id=2d8ecb7c&lang=less"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ecb7c"]])

export default __exports__